import { StatusTag } from "../../../../components/chips/status-tag";
import { CONST_INVITATION_STATUS_LIST } from "../../../../constants/lists";
import { getInvitationStatus } from "../../../../services/utils";

function InvitationStatus({ data }) {
  const status = getInvitationStatus(data);
  const statusConfig = CONST_INVITATION_STATUS_LIST[status];

  if (!statusConfig?.label) return null;

  const { fontColor, bgColor } = statusConfig;

  return (
    <StatusTag
      text={statusConfig.label}
      fontColor={fontColor}
      bgColor={bgColor}
    />
  );
}

export { InvitationStatus };
